import { render, staticRenderFns } from "./AutresAutorisationsDePratique.vue?vue&type=template&id=139d40ba"
import script from "./AutresAutorisationsDePratique.vue?vue&type=script&lang=js"
export * from "./AutresAutorisationsDePratique.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports